import React, {Component} from 'react';
import classNames from "classnames";

class SearchInput extends Component {
    componentDidMount(){
       // if(this.props.autoFocus) this.nameInput.focus();
    }

    render() {
        return(
            <input ref={(input) => { this.nameInput = input; }}  type="text" value={this.props.value} onChange={(e) => this.props.changeAction(e.target.value)} autoFocus={this.props.autoFocus}/>
        );
    }
}

class VehicleSelectionInput extends Component {
    constructor(props) {
        super(props);

        this.state = {
            enable : false,
            displayOptions : false,
            searchText : "",
            topPos : 0,
            leftPos : 0,
            largeur : 0
        };

        this.setWrapperRef = this.setWrapperRef.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    setWrapperRef(node) {
        this.wrapperRef = node;

        if(node!=null) this.setState( {topPos : node.parentNode.getBoundingClientRect().top, leftPos : (window.innerWidth>1024 ? node.parentNode.getBoundingClientRect().left :(window.innerWidth-node.getBoundingClientRect().width)/2), largeur : node.parentNode.style.paddingLeft + node.parentNode.style.paddingRight + node.parentNode.getBoundingClientRect().width});
        if(this.state.displayOptions && node!=null) console.log("elm "+node.parentNode.getBoundingClientRect().left+" "+node.getBoundingClientRect().width+"/"+window.innerWidth+"§"+(node.parentNode.style.paddingLeft + node.parentNode.style.paddingRight + node.parentNode.getBoundingClientRect().width))
    }

    show() {
        this.setState({displayOptions: true});
    }

    hide() {
        this.setState({displayOptions: false});//
    }

    handleClick() {
        if(!this.state.displayOptions && this.props.options.length > 0) {
            this.show();
        }
    }

    handleClickOutside(event) {
        if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
            this.hide();
        }
    }

    handleSelect(index) {
        this.hide();
        this.props.changeAction(index);
    }

    renderOptionDate(option) {
        return (
            <span>
                ({option.start_date} - {option.end_date?option.end_date:null})
            </span>
        );
    }

    renderOptions() {
        let optionGroups = [];
        const filteredOptions = this.props.options.map((option, index) => { return {...option, realIndex:index}}).filter(option => option.name.toLowerCase().indexOf(this.state.searchText.toLowerCase()) > -1);
        filteredOptions.forEach((option) => {
            if (optionGroups.indexOf(option.group_name) < 0) {
                optionGroups.push(option.group_name);
            }
        });

        return optionGroups.map(function (optionGroup) {
            return (
                <div key={optionGroup}>
                    <p className={"group_option"} style={{fontWeight: "bold"}}>{optionGroup}</p>
                    {filteredOptions.filter(option => option.group_name === optionGroup)
                        .map(function (option, index) {
                            return <div className={"vehicle_option"} key={option.id} onClick={() => this.handleSelect(option.realIndex)}>{option.name}{option.start_date ? this.renderOptionDate(option) : null}</div>
                    }.bind(this))}
                </div>
            )
        }.bind(this));
    }

    render() {
        const divClassNames = classNames(
            'form_input',
            'vehicle_selector',
            {
                'disabled' : !this.props.options.length > 0
            }
        );
        const isDesktop = window.innerWidth > 500;
        const mobilStyle= {
            top:"auto",
            marginTop:"-6px",
            marginLeft:"-6px",
            position:"absolute",
            width:this.state.largeur+"px"
        }
        return (
            <div className={divClassNames} onClick={() => {this.handleClick()}}>
                <p>{this.props.title}</p>
                {this.props.selected ?
                    <i className="material-icons success">
                        done
                    </i>
                    :
                    <i className="material-icons">
                        keyboard_arrow_down
                    </i>
                }
                {
                    this.state.displayOptions ?
                        (
                            <div ref={this.setWrapperRef} className={"vehicle_option_container"} style={mobilStyle}>
                                <span>{this.props.title}</span>
                                <SearchInput value={this.state.searchText} changeAction={(value) => this.setState({searchText:value})} autoFocus={isDesktop}/>
                                <div className={"options"}>
                                    {this.renderOptions()}
                                </div>
                            </div>
                        )
                        : null
                }
            </div>
        )
    }
}

export default VehicleSelectionInput;